import React, { Suspense } from "react";
import { arabicRoutes, authenticationRoute, blogroutes, listingroutes, pageroutes, publicRoutes, usermodule } from "./router.link";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Header from "../common/header";
import Footer from "../common/footer";
import Progress from "../common/progressbar";
import ArabicLayout from "./arabicLayout";

const RouteFallback = () => <div style={{ minHeight: "60vh" }} />;

const AllRoutes = () => {
  const HeaderLayout = () => (
    <>
      <Header />
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
      <Progress/>
      <Footer />
    </>
  );

  const PageLayout = () => (
    <>
      <Header />
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
      <Progress/>
      <Footer />
    </>
  );
  const UserLayout = () => (
    <>
      <Header />
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
      <Progress/>
      <Footer />
    </>
  );




  return (
    <>
      <Routes>
        <Route path={"/"}  element={<HeaderLayout />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}

        </Route>
        <Route path={"/ar"} element={<ArabicLayout />}>
          {arabicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route path={"/package"} element={<PageLayout />}>
          {listingroutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route path={"/pages"} element={<PageLayout />}>
          {pageroutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route path={"/blog"} element={<PageLayout />}>
          {blogroutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route path={"/user"} element={<UserLayout />}>
          {usermodule.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route path={"/"}>
          {authenticationRoute.map((route, idx) => (
            <Route
              path={route.path}
              element={<Suspense fallback={<RouteFallback />}>{route.element}</Suspense>}
              key={idx}
            />
          ))}
        </Route>
        <Route path={"/"}>
            <Route path="/"  element={<Navigate to="/"/>}  />
        </Route>
      </Routes>
    </>
  );
};
export default AllRoutes;
